import { render, staticRenderFns } from "./WaitingTimeCard.vue?vue&type=template&id=7df7c0ca&scoped=true&"
import script from "./WaitingTimeCard.vue?vue&type=script&lang=js&"
export * from "./WaitingTimeCard.vue?vue&type=script&lang=js&"
import style0 from "./WaitingTimeCard.vue?vue&type=style&index=0&id=7df7c0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df7c0ca",
  null
  
)

export default component.exports